import { render, staticRenderFns } from "./Maro.vue?vue&type=template&id=9ac1227e&scoped=true&"
import script from "./Maro.vue?vue&type=script&lang=js&"
export * from "./Maro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac1227e",
  null
  
)

export default component.exports